import { getFieldIconBy, getFieldLabelBy } from 'src/pages/mockup/assistFunc.js';
import TreeNode from './TreeNode';

export default class extends TreeNode {
    constructor (type) {
        super();
        this.type = type;
        this.innertype = 'field';
        this.label = getFieldLabelBy(type);
        this.icon = getFieldIconBy(type);
        this.value = '';
        this.tag = '';
        this.symbols = '';
        this.min = '';
        this.max = '';
        this.hint = '';
        this.fixd = false;
        this.required = false;
    }
}
